module.exports = __webpack_public_path__ + "static/media/OpenedGift.08e89c53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/OpenedGift.svg
// module id = 1866
// module chunks = 51